module.exports = __webpack_public_path__ + "static/media/12_l_lustra_2_34_2.41.b59fa47d.png";